const tool = {

    numMulti(num1, num2) {
	    var baseNum = 0;
	    try {
	        baseNum += num1.toString().split(".")[1].length;
	    } catch (e) {
	    }
	    try {
	        baseNum += num2.toString().split(".")[1].length;
	    } catch (e) {
	    }
	    return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
	},

    //验证数字
    numberValidate (val) {
        var reg = new RegExp("^[0-9]*$")
        if(!reg.test(val)){
            return false
        }
        return true
    },
    
    //验证整数
    integerNumberValidate(val){
    	var reg = new RegExp(/[^0-9]+/g,'')
    	if(!reg.test(val)){
    		return false
    	}
    	return true
    },
    
    //验证中文
    chineseValidate (val) {
        var reg = new RegExp('^((?!([\u3000-\u303F]))[\u2E80-\uFE4F]|\·)*((?!([\u3000-\u303F]))[\u2E80-\uFE4F])(\·)*$')
        if (!reg.test(val)) {
            // alert("不全是中文")
            return false
        } else {
            //alert("全是中文")
            return true
        }
    },

    //验证中英文
    chEgValidate (val) {
        var reg = new RegExp('^([\u4E00-\u9FA5]|[\a-zA-Z])+$')
        if (!reg.test(val)) {
            // alert("不全是英文")
            return false
        } else {
            // alert("全是英文")
            return true
        }
    },

    //验证英文
    englishValidate (val) {
        var reg = new RegExp('^[A-Za-z]+$')
        if (!reg.test(val)) {
            // alert("不全是英文")
            return false
        } else {
            // alert("全是英文")
            return true
        }
    },

    //验证英文大写
    englishUpperValidate (val) {
        var reg = new RegExp('^[A-Z]+$')
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },

    //验证英文小写
    englishUpperValidate (val) {
        var reg = new RegExp('^[a-z]+$')
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },

    //验证英文公司名
    companyEnValidate (val) {
        var reg = new RegExp('^[A-Za-z\.\s\,]+$')
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },

    //验证手机号
    phoneNoValidate (val) {
        //var reg = new RegExp('^(0|86|17951)?(13[0-9]|15[012356789]|17[2678]|18[0-9]|14[57])[0-9]{8}$')
        if (!(/^(1[3-9][0-9])[0-9]{8}$/).test(val)) {
            return false
        } else {
            return true
        }
    },
    
     //身份证号验证
    identityCodeValid3 (code) { 
        var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
        var tip = "";
        var pass= true;
        
        if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
            tip = "身份证号格式错误";
            pass = false;
        }else if(!city[code.substr(0,2)]){
            tip = "地址编码错误";
            pass = false;
        }else{
            //18位身份证需要验证最后一位校验位
            if(code.length == 18){
                code = code.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                //校验位
                var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++)
                {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                var last = parity[sum % 11];
                if(parity[sum % 11] != code[17]){
                    tip = "校验位错误";
                    pass =false;
                }
            }
        }
        return pass;
    },
    
    identifyNumValidate2 (StrNo) {
          StrNo = StrNo.toString();
          StrNo = StrNo.trim();
        if (StrNo.length == 18) {
            var a, b, c;
            if(!/^[0-9]+$/.test(StrNo.substr(0, 17))){
            	return false
            }
            //身份证验证是否全为数字
            /*if (isNaN(StrNo.substr(0, 17))) {
                return false
            }*/
            a = parseInt(StrNo.substr(0, 1)) * 7 + parseInt(StrNo.substr(1, 1)) * 9 + parseInt(StrNo.substr(2, 1)) * 10;
            a = a + parseInt(StrNo.substr(3, 1)) * 5 + parseInt(StrNo.substr(4, 1)) * 8 + parseInt(StrNo.substr(5, 1)) * 4;
            a = a + parseInt(StrNo.substr(6, 1)) * 2 + parseInt(StrNo.substr(7, 1)) * 1 + parseInt(StrNo.substr(8, 1)) * 6;
            a = a + parseInt(StrNo.substr(9, 1)) * 3 + parseInt(StrNo.substr(10, 1)) * 7 + parseInt(StrNo.substr(11, 1)) * 9;
            a = a + parseInt(StrNo.substr(12, 1)) * 10 + parseInt(StrNo.substr(13, 1)) * 5 + parseInt(StrNo.substr(14, 1)) * 8;
            a = a + parseInt(StrNo.substr(15, 1)) * 4 + parseInt(StrNo.substr(16, 1)) * 2;
            b = a % 11;

            if (b == 2) //最后一位为校验位   
            {
                c = StrNo.substr(17, 1).toUpperCase(); //转为大写X   
            } else {
                c = parseInt(StrNo.substr(17, 1));
            }

            switch (b) {
                case 0:
                    if (c != 1) {
                        // alert("身份证好号码校验位错:最后一位应该为:1");
                        return false;
                    }
                    break;
                case 1:
                    if (c != 0) {
                        // alert("身份证好号码校验位错:最后一位应该为:0");
                        return false;
                    }
                    break;
                case 2:
                    if (c != "X") {
                        // alert("身份证好号码校验位错:最后一位应该为:X");
                        return false;
                    }
                    break;
                case 3:
                    if (c != 9) {
                        // alert("身份证好号码校验位错:最后一位应该为:9");
                        return false;
                    }
                    break;
                case 4:
                    if (c != 8) {
                        // alert("身份证好号码校验位错:最后一位应该为:8");
                        return false;
                    }
                    break;
                case 5:
                    if (c != 7) {
                        // alert("身份证好号码校验位错:最后一位应该为:7");
                        return false;
                    }
                    break;
                case 6:
                    if (c != 6) {
                        // alert("身份证好号码校验位错:最后一位应该为:6");
                        return false;
                    }
                    break;
                case 7:
                    if (c != 5) {
                        // alert("身份证好号码校验位错:最后一位应该为:5");
                        return false;
                    }
                    break;
                case 8:
                    if (c != 4) {
                        // alert("身份证好号码校验位错:最后一位应该为:4");
                        return false;
                    }
                    break;
                case 9:
                    if (c != 3) {
                        // alert("身份证好号码校验位错:最后一位应该为:3");
                        return false;
                    }
                    break;
                case 10:
                    if (c != 2) {
                        // alert("身份证好号码校验位错:最后一位应该为:2");
                        return false
                    }
            }
        } else //15位身份证号   
        {
            if (isNaN(StrNo)) {
                // alert("身份证号码错误,前15位不能含有英文字母！");
                return false;
            }
        }

        switch (StrNo.length) {
            case 15:
                return true;
            case 18:
                return true;
        }
        // alert("输入的身份证号码必须为15位或者18位！");   
        return false;
    },

    //验证座机号
    telValidate (val) {
        var reg = new RegExp('^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$') // 区号+座机号码+分机号码
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },
    
    //验证邮箱
    isEmail (val) {
        var reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },

    //验证手机座机
    phoneNoTelValidate (val) {
        var reg = new RegExp('^(((0|86|17951)?(13[0-9]|15[012356789]|17[2678]|18[0-9]|14[57])[0-9]{8})|((0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?))$')
        if (!reg.test(val)) {
            return false
        } else {
            return true
        }
    },

    //时间格式化
    dateFmt(fmt,date){
        var o = {   
            "M+" : date.getMonth()+1,                 //月份   
            "d+" : date.getDate(),                    //日   
            "h+" : date.getHours(),                   //小时   
            "m+" : date.getMinutes(),                 //分   
            "s+" : date.getSeconds(),                 //秒   
            "q+" : Math.floor((date.getMonth()+3)/3), //季度   
            "S"  : date.getMilliseconds()             //毫秒   
        } 
        if(/(y+)/.test(fmt))   
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
        for(var k in o)   
            if(new RegExp("("+ k +")").test(fmt))   
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
        return fmt;   
    } ,
    
    getBirthByIdNum(idNum){
    	if(idNum){
    		var birthStr=idNum.substring(6,10) + "-" +idNum.substring(10,12) + "-" + idNum.substring(12,14);
    		//var birthDate = new Date(birthStr);
    		return birthStr;
    	}
	    return null;
    },
    getUrlParamByName(name) {
		var urlStr = window.location.href;
		if (!urlStr) {
			urlStr = window.location.search;
		}
		var match = RegExp('[?&]' + name + '=([^&]*)').exec(decodeURIComponent(window.location.href));
	    return match && decodeURIComponent(match[1].replace('/+/g', ' '));
	},
	
	getUser() {
		var userStr = localStorage.getItem('yy_user');
		if (userStr) {
			return JSON.parse(userStr);
		}
		return null;
	},
	
	setUser(user) {
		localStorage.setItem('yy_user', JSON.stringify(user));
	},
	
	removeUser() {
		localStorage.removeItem('yy_user');
	},
	
	isLoggedIn() {
		var user = this.getUser();
		return user && user.userId;
	},
	
	isBindInfo() {
		var user = this.getUser();
		return user && user.isBind;
	},
	
	getDoctorUser() {
		var doctorStr = localStorage.getItem('yy_doctor_user');
		if (doctorStr) {
			return JSON.parse(doctorStr);
		}
		return null;
	},
	
	setDoctorUser(doctorUser) {
		localStorage.setItem('yy_doctor_user', JSON.stringify(doctorUser));
	},
	
	removeDoctorUser() {
		localStorage.removeItem('yy_doctor_user');
	},
	
	isDoctorLoggedIn() {
		var doctorUser = this.getDoctorUser();
		return doctorUser && doctorUser.userId;
	},
	
	// 清除URL中的参数
	clearUrlParams() {
		const url = window.location.href;
		const hashIndex = url.indexOf('#');
		if (hashIndex !== -1) {
			const cleanUrl = url.substring(0, url.indexOf('?')) + url.substring(hashIndex);
			window.history.replaceState({}, document.title, cleanUrl);
		} else {
			const cleanUrl = url.substring(0, url.indexOf('?'));
			window.history.replaceState({}, document.title, cleanUrl);
		}
	},
	
	// 检查授权状态是否有效
	isAuthorized() {
		const user = this.getUser();
		if (!user) return false;
		
		// 检查是否有授权时间
		if (!user.authorizeTime) return false;
		
		// 检查授权是否过期（24小时）
		const now = new Date().getTime();
		const authorizeTime = new Date(user.authorizeTime).getTime();
		const expireTime = 24 * 60 * 60 * 1000; // 24小时
		
		return (now - authorizeTime) < expireTime;
	},
	
	// 检查医生授权状态是否有效
	isDoctorAuthorized() {
		const doctorUser = this.getDoctorUser();
		if (!doctorUser) return false;
		
		// 检查是否有授权时间
		if (!doctorUser.authorizeTime) return false;
		
		// 检查授权是否过期（24小时）
		const now = new Date().getTime();
		const authorizeTime = new Date(doctorUser.authorizeTime).getTime();
		const expireTime = 24 * 60 * 60 * 1000; // 24小时
		
		return (now - authorizeTime) < expireTime;
	}
}

export default tool


// WEBPACK FOOTER //
// ./src/assets/js/tool.js